import { initDialog } from '../lib/dialog';
import { submitForm } from '../lib/submitForm';
import { timeout } from '../lib/timeout';
import {
  dispatchEvent,
  formFailureEvent,
  formSubmitEvent,
} from '../lib/events';

async function handleGenericFormSubmit(form) {
  submitForm(form, {
    onSubmit: async (response, params) => {
      dispatchEvent(formSubmitEvent(params));
      form.reset();
      const dialogId = form.dataset.successDialog
        ? form.dataset.successDialog
        : 'generic-success-dialog';
      const successDialog = initDialog(dialogId);

      const redirect = params?.redirect_on_success || '';
      if (redirect) {
        await timeout(300);
        window.location.assign(redirect);
      } else {
        successDialog.show();
        await timeout(6000);
        successDialog.hide();
      }
    },
    onFailure: async (response, params) => {
      dispatchEvent(formFailureEvent(params));
      const redirect = params?.redirect_on_failure || '';
      if (redirect) {
        await timeout(300);
        if (redirect) window.location.assign(redirect);
      }
    },
  });
}

function initGenericForm(form) {
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    handleGenericFormSubmit(form);
  });
}

export function initForms() {
  const genericForms = document.querySelectorAll('.js-generic-form');

  genericForms.forEach((form) => initGenericForm(form));
}
